export default __webpack_public_path__ + "static/media/1.ac7c7616.png";